module.exports = "pegasus_template/assets/two-column-text-image-one-column-text-preview.png";